import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import CONSTANTS from '../constants/constant';
import AccountService from '../services/Account';
import { useUser } from '../store/hooks/hooks';

import CheckoutIcon from '../statics/images/checkout.gif';
import './CheckinCheckout.scss';
import WorkingTimeAPI from '../services/WorkingTimeAPI';

interface Props {
  ignorePage?: string;
  onSuccess?: () => void;
}

export default function CheckinCheckout(props: Props) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isCheckIn, setCheckIn] = useState<boolean>(false);
  const [visibleCheckIn, setVisibleCheckIn] = useState<boolean>(false);

  const location = useLocation();
  const user = useUser();

  const handleDialogHide = () => {
    setMessage('');
    setCheckIn(false);
    setVisible(false);
  };

  const handleOKClick = () => {
    handleDialogHide();
    if (props.onSuccess) {
      props.onSuccess();
    }
  };

  const handleCheckInOut = async () => {
    setLoading(true);
    const result = await AccountService.checkInOut();
    if (result.success && result.data.id > 0) {
      if (result.data.start_time !== result.data.end_time) {
        setMessage(
          `<div>Bạn đã CHECK OUT thành công lúc ${moment(result.data.end_time).format(
            CONSTANTS.DATE_FORMAT.LONG,
          )}</div><div><b>TỔNG SỐ GIỜ LÀM VIỆC: ${result.data.working_hours}</b></div>`,
        );
      } else {
        setMessage(`Bạn đã CHECK IN thành công lúc ${moment(result.data.end_time).format(CONSTANTS.DATE_FORMAT.LONG)}`);
      }
      if (isCheckIn && props.onSuccess) {
        props.onSuccess();
      }
    } else {
      setMessage(result.message);
    }
    setLoading(false);
    setVisible(true);
  };

  const fetchCheckInOut = async () => {
    let isViCheckIn = true;

    const today = moment.tz(CONSTANTS.DATE_FORMAT.TIMEZONE);

    const leaveResult = await WorkingTimeAPI.fetchLeaveRequests({ userId: user.id });
    const leaveData = (leaveResult && leaveResult.success && leaveResult.data ? leaveResult.data : [])
      .filter((item: any) => item.status === 'APPROVED')
      .map((item: any) => ({ ...item, working_type: item.request_type === 'LEAVE' ? 'leave' : 'outside' }));

    const holidayResult = await WorkingTimeAPI.fetchHolidayDaysList();
    const holidayData = (holidayResult && holidayResult.success && holidayResult.data ? holidayResult.data : []).map(
      (item: any) => ({ ...item, working_type: 'holiday' }),
    );
    const workingAssignedDaysResult = await WorkingTimeAPI.fetchWorkingAssignedDays({
      from: moment.tz(CONSTANTS.DATE_FORMAT.TIMEZONE).startOf('day').toISOString(),
      to: moment.tz(CONSTANTS.DATE_FORMAT.TIMEZONE).endOf('day').toISOString(),
    });
    const workingAssignedDaysData = (
      workingAssignedDaysResult && workingAssignedDaysResult.success && workingAssignedDaysResult.data
        ? workingAssignedDaysResult.data
        : []
    )
      .filter(
        (item: any) =>
          item.is_working &&
          today.isBetween(
            moment.tz(item.start_date, CONSTANTS.DATE_FORMAT.TIMEZONE).startOf('day'),
            moment.tz(item.end_date, CONSTANTS.DATE_FORMAT.TIMEZONE).endOf('day'),
          ),
      )
      .map((item: any) => {
        return { ...item, working_type: 'working_assigned' };
      });

    const ghglvResult = await WorkingTimeAPI.fetchGioiHanGioLamViecByUser();
    const ghglvData = ghglvResult && ghglvResult.success && ghglvResult.data.length > 0 ? ghglvResult.data[0] : {};

    if (
      leaveData.some(
        (item: any) =>
          item.working_type === 'leave' &&
          today.isBetween(
            moment.tz(item.start_date, CONSTANTS.DATE_FORMAT.TIMEZONE),
            moment.tz(item.end_date, CONSTANTS.DATE_FORMAT.TIMEZONE),
          ),
      )
    ) {
      isViCheckIn = false;
    }

    if (
      holidayData.some(
        (item: any) =>
          item.working_type === 'holiday' &&
          today.isBetween(
            moment.tz(item.start_date, CONSTANTS.DATE_FORMAT.TIMEZONE),
            moment.tz(item.end_date, CONSTANTS.DATE_FORMAT.TIMEZONE),
          ),
      )
    ) {
      isViCheckIn = false;
    }

    if (
      !workingAssignedDaysData.some((workingItem: any) =>
        today.isBetween(
          moment.tz(workingItem.start_date, CONSTANTS.DATE_FORMAT.TIMEZONE).startOf('day'),
          moment.tz(workingItem.end_date, CONSTANTS.DATE_FORMAT.TIMEZONE).endOf('day'),
        ),
      )
    ) {
      isViCheckIn = false;
    }

    if (!isViCheckIn && ghglvData.is_ot) {
      isViCheckIn = true;
    }

    if (isViCheckIn) {
      setVisibleCheckIn(true);
      const result = await AccountService.fetchCheckInOut();
      console.log(result);
      if (result.success) {
        setCheckIn(isEmpty(result.data));
      }
    }
  };

  useEffect(() => {
    fetchCheckInOut();
  }, []);

  return (isEmpty(props.ignorePage) || (props.ignorePage && location.pathname.indexOf(props.ignorePage) < 0)) &&
    (isCheckIn || location.pathname.indexOf('/working-time') >= 0) &&
    user.email !== 'ADMIN1' &&
    moment().get('hours') >= 6 &&
    visibleCheckIn ? (
    <div className="fingerprint-wrapper" title="Check In">
      {isLoading ? (
        <div>
          <i className="pi pi-spin pi-spinner" />
        </div>
      ) : isCheckIn ? (
        <>
          <span>CHECK IN</span>
          <img src={CheckoutIcon} alt="fingerprint" onClick={handleCheckInOut} />
        </>
      ) : (
        <>
          <span>CHECK OUT</span>
          <img src={CheckoutIcon} alt="fingerprint" onClick={handleCheckInOut} />
          {/* <img src={FingerprintIcon} alt="fingerprint" onClick={handleCheckInOut} /> */}
        </>
      )}
      <Dialog
        appendTo={document.body}
        header="Thông báo"
        visible={visible}
        style={{ width: '450px' }}
        onHide={handleDialogHide}
        maximizable={false}
        className="confirm-dialog"
        closable={true}
      >
        <div className="text-center" dangerouslySetInnerHTML={{ __html: message }}></div>
        <div className="flex-center mt-8">
          <Button label="OK" className="p-button-primary p-button-sm" onClick={handleOKClick} />
        </div>
      </Dialog>
    </div>
  ) : (
    <></>
  );
}
